import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * This component handles resetting the window scroll position to the top
 * whenever the application's route (pathname) changes.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top of the window
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'instant' is preferred over 'smooth' for page transitions to avoid "jumping"
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;